import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../services';
import { APP } from '../config/app';

/**
 * Availabilities always carries `?routeId=` so the URL is never truly bare —
 * but page size still needs to be hydrated from storage to preserve "remember
 * my preference" across sessions. This guard adds `?size=N` to the URL when
 * size isn't already present, before the resolver runs.
 */
export const availabilitiesHydrationGuard: CanActivateFn = async (route, state) => {
  if (route.queryParamMap.has('size')) return true;

  const storage = inject(StorageService);
  const router = inject(Router);

  const storedSize = await storage.getAvailabilitiesPageSize();
  if (!storedSize || storedSize <= 0 || storedSize === APP.DEFAULT_PAGE_SIZE) return true;

  const path = state.url.split('?')[0];
  const queryParams: { [key: string]: string | number } = { size: storedSize };
  // Preserve any existing query params (routeId, etc.).
  for (const k of route.queryParamMap.keys) {
    const v = route.queryParamMap.get(k);
    if (v != null) queryParams[k] = v;
  }
  return router.createUrlTree([path], { queryParams });
};
